import React from "react";
import {useField} from "formik";
import CheckBox from "../../FormComponents/Checkbox";

const FormikCheckBox = props => {
    const [field] = useField(props)
    const { onChange } = field

    const newHandleChange = val => {
        onChange({target: { name: props.name, value: val}})
    }

    const {...newProps } = props;

    return (
        <CheckBox
            {...{...field, onChange: newHandleChange}}
            {...newProps}
        />
    )
}

export default FormikCheckBox